import { render } from "./WelcomeComponent.vue?vue&type=template&id=3d38acb4&scoped=true"
import script from "./WelcomeComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeComponent.vue?vue&type=script&lang=js"

import "./WelcomeComponent.vue?vue&type=style&index=0&id=3d38acb4&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d38acb4"]])

export default __exports__